__turbopack_context__.v({
  "header": "yElPlq_header",
  "hr": "yElPlq_hr",
  "label": "yElPlq_label",
  "price": "yElPlq_price",
  "styledForm": "yElPlq_styledForm",
});
